import React, { useContext } from 'react';
import {
  numberFormatter,
  priceFormatter,
  contactListingAddress,
} from 'src/utils/utils';
import { isListingOffMarket } from 'lib/checkListingStatus';
import { NO_DATA_PLACEHOLDER } from 'constants/labels';
import { getPropertyTypeByCode } from 'src/utils/getPropertyTypeByCode';
import {
  UnitPageContext,
  UnitPageContextInterface,
} from 'pages/[urlParam]/[urlBuildParam]/[urlUnitParam]';
import GalleryPopupHeaderV2 from './GalleryPopupHeaderV2';
import BathsCount from 'components/BathsCount';
import { UnitGalleryFavoriteButtonV2 } from './GalleryFavoriteButtonV2';

const UnitGalleryPopupHeaderV2: React.FC<{
  onClose?: () => void;
  photoCounter?: string;
}> = ({ onClose, photoCounter }) => {
  const { building, unit, listing, favorite, city } = useContext(
    UnitPageContext
  ) as UnitPageContextInterface;
  const { bedsTotal, sqft, price, statusCode, propertyTypeCode } = listing;

  const isMainStreetPartsExist =
    listing?.address?.streetNumber && listing?.address?.streetName;
  const primaryAddress = isMainStreetPartsExist
    ? contactListingAddress(listing?.address, city.name)
    : building.primaryAddress;

  const stats = [
    !isListingOffMarket(statusCode) ? priceFormatter(price) : null,
    `${bedsTotal} bds`,
    <>
      <BathsCount listing={listing} /> ba
    </>,
    `${sqft ? numberFormatter(sqft) : NO_DATA_PLACEHOLDER} sqft`,
  ].filter(Boolean) as React.ReactNode[];

  const name = `${building?.name} #${unit?.unique}`;

  return (
    <div className="relative">
      <GalleryPopupHeaderV2
        name={name}
        stats={stats}
        primaryAddress={primaryAddress}
        onClose={onClose}
        photoCounter={photoCounter}
        favoriteButton={(showLabel, useLargeIcons) => (
          <UnitGalleryFavoriteButtonV2
            unitId={unit.id}
            type={getPropertyTypeByCode(propertyTypeCode)}
            userFavorites={favorite}
            showLabel={showLabel}
            useLargeIcons={useLargeIcons}
          />
        )}
      />
    </div>
  );
};

export default UnitGalleryPopupHeaderV2;
